// This file is AUTOGENERATED, do not edit it manually!!!

export const common = {
    CanDeleteCategoryHasTask: 'Bu aktivitelerde kullanılan kategoriyi silmek imkansız.',
    Completed_Projects: 'Tamamlanamış projeleri',
    Completed_Tasks: 'Tamamlanmış aktiviteleri',
    next_month: 'Gelecek ay',
    next_week: 'Gelecek hafta',
    PortfolioLimitError: 'Team Edition\'da 60 portföy sınırına ulaştınız. Lütfen {brandName} Enterprise Edition\'a yükseltin.',
    previous_month: 'Önceki ay',
    previous_week: 'Önceki Hafta',
    previous_year: 'Önceki yıl',
    select: 'Seç',
    short_quarter0: 'Ç1',
    short_quarter1: 'Ç2',
    short_quarter2: 'Ç3',
    short_quarter3: 'Ç4',
    this_month: 'Bu ay',
    this_week: 'Bu hafta',
    this_year: 'Bu yıl',
    today: 'Bugün',
    yesterday: 'Dün',
};
